// extracted by mini-css-extract-plugin
module.exports = {"banner":"CookieBanner-module--banner--1bIk4","content":"CookieBanner-module--content--1Bz0N"};